import React, { useState } from 'react';
import CrudTable from '../../components/common/CrudTable';
import { requestAPI } from '../../api/services';
import { FiCheckCircle, FiClock } from 'react-icons/fi';

const RequestsAdmin = () => {
  const [refreshKey, setRefreshKey] = useState(0);

  const handleResolve = async (item) => {
    try {
      await requestAPI.update(item.id, { ...item, isRead: true });
      setRefreshKey(prev => prev + 1);
    } catch (err) {
      console.error("Failed to resolve request", err);
    }
  };

  const COLUMNS = [
    { key: 'fullName', label: 'Name' },
    { key: 'phone', label: 'Phone' },
    { 
      key: 'text', 
      label: 'Message', 
      render: (item) => (
        <div className="tooltip-container">
          <div style={{ maxWidth: 250, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {item.text || '—'}
          </div>
          {item.text?.length > 40 && <span className="tooltip-text">{item.text}</span>}
        </div>
      ) 
    },
    { 
      key: 'isRead', 
      label: 'Status', 
      render: (item) => (
        <span className={`badge ${item.isRead ? 'badge-success' : 'badge-warning'}`}>
          {item.isRead ? <><FiCheckCircle /> Resolved</> : <><FiClock /> Pending</>}
        </span>
      ) 
    },
    { key: 'createdAt', label: 'Date', render: (item) => item.createdAt?.replace('T', ' ').substring(0, 16) || '—' },
    {
      key: 'actions',
      label: 'Resolve',
      render: (item) => !item.isRead && (
        <button 
          className="btn btn-primary btn-sm" 
          onClick={() => handleResolve(item)}
          style={{ padding: '4px 12px', fontSize: '0.75rem' }}
        >
          Mark as Read
        </button>
      )
    }
  ];

  const FORM_FIELDS = [
    { name: 'fullName', label: 'Full Name', placeholder: 'John Doe' },
    { name: 'phone', label: 'Phone', placeholder: '+998901234567' },
    { name: 'text', label: 'Message', type: 'textarea', placeholder: 'Request details...' },
    { name: 'isRead', label: 'Is Resolved?', type: 'select', options: [{label: 'Yes', value: true}, {label: 'No', value: false}] },
  ];

  return (
    <CrudTable
      key={refreshKey}
      title="User Requests"
      entityName="Request"
      columns={COLUMNS}
      formFields={FORM_FIELDS}
      fetchData={async () => {
        const res = await requestAPI.getAll();
        const items = res.data?.data || [];
        // Sort: Unread first, then by date (newest first)
        return items.sort((a, b) => {
          if (a.isRead === b.isRead) {
            return new Date(b.createdAt) - new Date(a.createdAt);
          }
          return a.isRead ? 1 : -1;
        });
      }}
      onAdd={(data) => requestAPI.add(data)}
      onUpdate={(id, data) => requestAPI.update(id, data)}
      onDelete={(id) => requestAPI.delete(id)}
    />
  );
};

export default RequestsAdmin;
